/** Placement choices offered by the website embed builder. */
export type EmbedStyle = 'inline' | 'button' | 'custom';

/** Neutral default suitable for any campaign purpose. */
export const DEFAULT_EMBED_LABEL = 'Get started';
/** Default viewport for the embedded respondent experience. */
export const DEFAULT_EMBED_HEIGHT = 640;

/** Keep customer-supplied dimensions usable and prevent CSS injection. */
export function normalizeEmbedHeight(value: unknown): number {
  const height = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(height) && height >= 320 && height <= 1600
    ? Math.round(height) : DEFAULT_EMBED_HEIGHT;
}
